module.exports = __webpack_public_path__ + "images/application/logo-stamp-c9d74579.svg";